






































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "@/components/customer-header.vue";
import { GetDictionaryData, GetKepuVisitorList } from "@/request/common";
import Fankui from "@/components/fankui.vue";
import SecureFileViewer from "@/components/secure-file-viewer.vue";
@Component({
  components: {
    MainHeader,
    Fankui,
    SecureFileViewer,
  },
})
export default class Name extends mixins(listMixin) {
  private types: any[] = []; // 课程类别
  private types2: any[] = []; // 内容领域
  private data: any = [];
  private showFankui: any = false;
  private showFileViewer: boolean = false;
  private currentFileUrl: string = "";
  private currentFileName: string = "";
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private openFankui() {
    this.showFankui = true;
  }
  
  private closeFileViewer() {
    this.showFileViewer = false;
    this.currentFileUrl = "";
    this.currentFileName = "";
  }
  
  private goDetail(item: any) {
    // 拦截未登录
    const token = this.$store.state.token;
    const user = this.$store.state.user;
    if (!token || !user || !user.userId) {
      this.$confirm("查看更多内容请先登录", "登录", {
        customClass: "commonConfirm",
      }).then(() => {
        // 跳转登录
        this.$router.push("/access/login");
      });
    } else {
      if (item.file_type == "文件") {
        this.currentFileUrl = item.file[0].url;
        this.currentFileName = item.name || "文件预览";
        this.showFileViewer = true;
      } else {
        this.$router.push({
          path: "/keyan/detail",
          query: {
            id: item.id,
          },
        });
      }
    }
  }
  private ifSelected(type: any, id: any) {
    const index: any = this.filters[type].findIndex((val: any) => {
      return val == id;
    });
    if (index == -1) {
      return false;
    } else {
      return true;
    }
  }
  private changeTab(type: any, id: any) {
    // 如已经选中则移除，如果没选中就选中
    // const index: any = this.filters[type].findIndex((val: any) => {
    //   return val == id;
    // });
    // if (index == -1) {
    //   this.filters[type].push(id);
    // } else {
    //   this.filters[type].splice(index, 1);
    // }
    this.filters[type] = [id];
    this.search();
  }
  private getType() {
    const params: any = {
      params: {
        values: "课程类别",
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.types = res.data;
    });
  }
  private getType2() {
    const params: any = {
      params: {
        values: "内容领域",
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.types2 = res.data;
    });
  }
  getList() {
    console.log(this.filters);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        ordering: this.filters.ordering,
        page: this.filters.current_page,
        limit: 12,
        content_types: this.filters["内容领域"].join(","),
        content_levels: this.filters["课程类别"].join(","),
      },
    };
    localStorage.setItem("kepuListFilter", JSON.stringify(this.filters));
    GetKepuVisitorList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  private mounted() {
    this.filters["内容领域"] = [];
    this.filters["课程类别"] = [];
    this.filters.page_count = 12;
    if (localStorage.getItem("kepuListFilter")) {
      this.filters = JSON.parse(localStorage.getItem("kepuListFilter") as any);
    }
    this.getList();
    this.getType();
    this.getType2();
  }
}
